/* ELORIA VSL player.
   Re-implements the donor's VTurb smartplayer v4 behaviour for player "Tinnito_V5_01072026", read from
   its config (src/vturb_player.js) and its source (src/vturb/smartplayer.js):

   - style: bigPlay only. progressBar / videoTime / rewind / forward / speed / volume / fullscreen are all
     off, so the visitor never sees the length of the video or how much is left, and cannot seek.
   - smartAutoPlay: muted autoplay looping 0..371 s under the "Your Video Is Playing / Click To Unmute"
     card; a tap restarts the video from 0 with sound (dispatchAutoplayClickedEvent: volume 100, seek(0),
     muted=false, play).
   - fakeBar (alpha 2, height 10, #6d388b): width = 100 * (1 - (p - 1)^2)^(1/alpha), p = currentTime /
     duration, synced every 40 ms while playing - fast at the start, crawling at the end. Shown only
     once the video has been played with sound.
   - playback.disablePause false: on desktop a click pauses / resumes; on touch the first tap only
     "shows the controls" for 3.5 s (BarController.touch, hideTime 3500) and a second tap inside that
     window pauses.
   - resume: position saved from 5 s on, keyed by player id; on return the video is parked at that point
     under "You have already started watching this video" with Continue watching / Start from beginning.
   - the page's own CTA script (kept verbatim) finds this <video> and reveals the order block at 1291 s.

   Video: HLS cut of tinnito_discovery5_eloria_email_v1.mp4 in our Shopify Files (Files refuses videos
   over 600 s). Safari / iOS play the playlist natively, everyone else through hls.js. */
(function () {
  'use strict';

  var CFG = {
    startAt: 0,
    endAt: 371,
    fakeBarAlpha: 2,
    hideTime: 3500,
    resumeMin: 5,
    texts: {
      sap1: 'Your Video Is Playing',
      sap2: 'Click To Unmute',
      resumeTitle: 'You have already started watching this video',
      resumePlay: 'Continue watching',
      resumeReplay: 'Start from beginning',
      watchedTitle: 'You have already watched this video!',
      watchedReplay: 'Watch again'
    }
  };

  var ICON_PLAY = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="2 2 20 20"><g fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"><path d="M7.5 6.9Q7.5 5.1 9.05 6.03L17.2 10.97Q18.9 12 17.2 13.03L9.05 17.97Q7.5 18.9 7.5 17.1Z" /></g></svg>';
  var ICON_PAUSE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="1.565 1.565 20.87 20.87"><g fill="none" stroke="currentColor" stroke-width="1.522" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="5" width="4.5" height="14" rx="1.5" /><rect x="13.5" y="5" width="4.5" height="14" rx="1.5" /></g></svg>';
  var ICON_REWIND = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="1.565 1.565 20.87 20.87"><g fill="none" stroke="currentColor" stroke-width="1.304" stroke-linecap="round" stroke-linejoin="round"><path d="M5.2 11.65A7.5 7.5 0 1 0 7.4 6.35L5.2 8.55" /><path d="M5.2 4.4V8.55H9.35" /></g></svg>';

  // VTurb's isMobile(): touch user agents
  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  // VTurb keeps "<id>-resume" plus "expire_mixin_<id>-resume" = now + 30 days (checked 23.10 in the donor's
  // localStorage), and writes it only once the video plays with sound.
  var RESUME_TTL = 30 * 24 * 3600 * 1000;
  function store(key, val) {
    try {
      if (val === undefined) {
        var exp = parseFloat(localStorage.getItem('expire_' + key));
        var v = localStorage.getItem(key);
        if (v === null || (exp && exp < Date.now())) return null;
        return parseFloat(v);
      }
      localStorage.setItem(key, String(val));
      localStorage.setItem('expire_' + key, String(Date.now() + RESUME_TTL));
    } catch (e) { return null; }
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }

  function mount(host) {
    var src = host.getAttribute('data-src');
    var poster = host.getAttribute('data-poster');
    var hlsLib = host.getAttribute('data-hls');
    var icon = host.getAttribute('data-sap-icon');
    var sim = host.getAttribute('data-sap-sim');
    var key = 'tnv-resume-' + host.id;
    var mobile = isMobile();

    var player = el('div', 'tnv-player');
    var video = document.createElement('video');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('preload', 'auto');
    video.setAttribute('disableremoteplayback', '');
    video.setAttribute('x-webkit-airplay', 'deny');
    if (poster) video.setAttribute('poster', poster);
    video.controls = false;
    player.appendChild(video);

    var bezel = el('div', 'tnv-bezel');
    var bezelIcon = el('span', 'tnv-bezel-icon');
    bezel.appendChild(bezelIcon);
    player.appendChild(bezel);

    var bigplay = el('div', 'tnv-bigplay', ICON_PLAY);
    bigplay.setAttribute('aria-label', 'Play video');
    bigplay.hidden = true;
    player.appendChild(bigplay);

    var fakebar = el('div', 'tnv-fakebar');
    fakebar.hidden = true;
    player.appendChild(fakebar);

    host.innerHTML = '';
    host.appendChild(player);

    // width classes drive the em-based sizes, exactly like VTurb's m-w-* classes
    function sizeClass() {
      var w = player.getBoundingClientRect().width;
      player.classList.remove('m-w-360', 'm-w-480', 'm-w-550', 'm-w-768');
      player.classList.add(w <= 360 ? 'm-w-360' : w <= 480 ? 'm-w-480' : w <= 550 ? 'm-w-550' : 'm-w-768');
      if (sapCanvas) sapCanvas.style.transform = 'scale(' + (w / 1080) + ')';
    }

    // ---- source ----
    // Safari / iOS play the adaptive playlist natively. Everyone else goes through hls.js even when the
    // browser claims native HLS: Chrome's own HLS (2026) parks on the lowest rung (202x360 checked 23.10),
    // while hls.js starts on the first rung (404x720) and adapts, as the donor's player does.
    var apple = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && !/CriOS|FxiOS/.test(navigator.userAgent);
    var hasMse = !!(window.MediaSource || window.ManagedMediaSource || window.WebKitMediaSource);
    if ((apple || !hasMse) && video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
    } else {
      var s = document.createElement('script');
      s.src = hlsLib;
      s.onload = function () {
        if (window.Hls && window.Hls.isSupported()) {
          var hls = new window.Hls({ maxBufferLength: 30, startPosition: -1 });
          hls.loadSource(src);
          hls.attachMedia(video);
        } else {
          video.src = src;
        }
      };
      document.head.appendChild(s);
    }

    var played = false;      // played with sound (VTurb: blockers "played")
    var sap = null, sapCanvas = null;
    var resume = null;

    // ---- fake bar ----
    var barTimer = null;
    function barWidth(p) { return 100 * Math.pow(1 - (p - 1) * (p - 1), 1 / CFG.fakeBarAlpha); }
    function syncBar() {
      if (!played) { fakebar.hidden = true; return; }
      var d = video.duration, p = video.currentTime / d || 0;
      if (p === Infinity) { fakebar.style.width = '0%'; fakebar.hidden = true; return; }
      fakebar.hidden = false;
      fakebar.style.width = barWidth(p) + '%';
    }
    video.addEventListener('play', function () { if (!barTimer) barTimer = setInterval(syncBar, 40); });
    video.addEventListener('pause', function () { clearInterval(barTimer); barTimer = null; syncBar(); });
    video.addEventListener('timeupdate', function () { if (video.paused) syncBar(); });
    video.addEventListener('loadeddata', syncBar);

    // ---- controls bar state (no visible controls, but it gates the touch-to-pause) ----
    var showing = false, hideT = null;
    function show() {
      if (resume || sap || !played) return;
      clearTimeout(hideT);
      showing = true;
      player.classList.add('show-controls');
      hideT = setTimeout(function () { showing = false; player.classList.remove('show-controls'); }, CFG.hideTime);
    }

    function flash(svg) {
      bezelIcon.innerHTML = svg;
      bezelIcon.classList.remove('is-anim');
      void bezelIcon.offsetWidth;
      bezelIcon.classList.add('is-anim');
    }

    function toggle() {
      if (video.paused) { video.play(); } else { video.pause(); }
      show();
    }

    function renderBigplay() {
      bigplay.hidden = !(played && video.paused && !resume);
    }
    video.addEventListener('pause', function () { renderBigplay(); if (played && !resume) flash(ICON_PAUSE); });
    video.addEventListener('play', function () { renderBigplay(); if (played) flash(ICON_PLAY); });

    player.addEventListener('click', function (e) {
      if (sap || resume) return;
      if (!played) { toggle(); return; }
      e.preventDefault();
      if (showing) { toggle(); } else { show(); }
    });
    bigplay.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      toggle();
    });
    if (!mobile) {
      player.addEventListener('mousemove', show);
      player.addEventListener('mouseenter', show);
    }

    // ---- resume position ----
    video.addEventListener('timeupdate', function () {
      if (!played || video.currentTime < CFG.resumeMin) return;
      store(key, Math.floor(video.currentTime));
    });
    video.addEventListener('ended', function () { if (played) store(key, -1); });

    // ---- smart autoplay ----
    function onSapTime() {
      if (!sap) return;
      var t = video.currentTime;
      if (t < CFG.startAt) video.currentTime = CFG.startAt;
      if (t >= CFG.endAt) video.currentTime = CFG.startAt;
    }
    function startSap() {
      sap = el('div', 'tnv-sap');
      sapCanvas = el('div', 'tnv-sap-canvas');
      sapCanvas.appendChild(el('div', 'tnv-sap-box'));
      var t1 = el('span', 'tnv-sap-text tnv-sap-text--1'); t1.textContent = CFG.texts.sap1;
      var t2 = el('span', 'tnv-sap-text tnv-sap-text--2'); t2.textContent = CFG.texts.sap2;
      var pic = el('picture', 'tnv-sap-img');
      var img = document.createElement('img');
      img.src = icon; img.alt = 'Your video has already started';
      pic.appendChild(img);
      sapCanvas.appendChild(t1); sapCanvas.appendChild(t2); sapCanvas.appendChild(pic);
      sap.appendChild(sapCanvas);
      player.appendChild(sap);
      sizeClass();
      video.muted = true;
      video.setAttribute('muted', '');   // VTurb starts it with play(), no autoplay attribute
      video.addEventListener('timeupdate', onSapTime);
      // retryPlaybackOrStartSimulator: 5 retries 50 ms apart, then - if the video still has not moved -
      // a silent 10 s loop of the opening ("smartautoplay-0s.mp4") under the card. Safari / iOS get it
      // as an <img> (Safari plays mp4 in <img>, which Low Power Mode does not block), others a muted video.
      var tries = 0;
      (function attempt() {
        var p = video.play();
        if (p && p.catch) p.catch(function () {
          if (!sap) return;
          if (++tries <= 5) {
            setTimeout(function () { if (video.currentTime <= CFG.startAt + .01) attempt(); }, 50);
          } else if (sim) {
            startSimulator();
          }
        });
      })();
      sap.addEventListener('click', unmute);
    }
    var simEl = null;
    function startSimulator() {
      var apple = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) || /iPad|iPhone|iPod/.test(navigator.userAgent);
      simEl = document.createElement(apple ? 'img' : 'video');
      simEl.className = 'tnv-sap-sim';
      if (apple) {
        simEl.alt = 'Smart autoplay simulator';
      } else {
        simEl.muted = true; simEl.loop = true; simEl.autoplay = true;
        simEl.setAttribute('muted', ''); simEl.setAttribute('playsinline', ''); simEl.setAttribute('preload', 'metadata');
      }
      simEl.src = sim;
      player.insertBefore(simEl, sap);
    }
    function unmute(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (!sap) return;
      if (simEl) { simEl.parentNode.removeChild(simEl); simEl = null; }
      video.removeEventListener('timeupdate', onSapTime);
      sap.parentNode.removeChild(sap);
      sap = null; sapCanvas = null;
      played = true;
      video.volume = 1;
      video.currentTime = 0;
      video.muted = false;
      video.removeAttribute('muted');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      renderBigplay();
    }

    // ---- resume overlay ----
    function startResume(pos) {
      var watched = pos === -1;
      resume = el('div', 'tnv-resume');
      var content = el('div', 'tnv-resume-content');
      var title = el('div', 'tnv-resume-title');
      title.textContent = watched ? CFG.texts.watchedTitle : CFG.texts.resumeTitle;
      var actions = el('div', 'tnv-resume-actions');
      if (!watched) {
        var play = el('div', 'tnv-resume-play', '<span class="tnv-resume-icon">' + ICON_PLAY + '</span><span class="tnv-resume-text"></span>');
        play.lastChild.textContent = CFG.texts.resumePlay;
        play.addEventListener('click', function (e) { e.stopPropagation(); close(); video.play(); });
        actions.appendChild(play);
      }
      var rw = el('div', 'tnv-resume-rewind', '<span class="tnv-resume-icon">' + ICON_REWIND + '</span><span class="tnv-resume-text"></span>');
      rw.lastChild.textContent = watched ? CFG.texts.watchedReplay : CFG.texts.resumeReplay;
      rw.addEventListener('click', function (e) { e.stopPropagation(); close(); video.currentTime = 0; video.play(); });
      actions.appendChild(rw);
      content.appendChild(title); content.appendChild(actions);
      resume.appendChild(content);
      resume.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); });
      player.appendChild(resume);
      if (!watched) {
        var seek = function () { try { video.currentTime = pos; } catch (er) {} };
        if (video.readyState >= 1) seek(); else video.addEventListener('loadedmetadata', seek, { once: true });
      }
      function close() {
        resume.parentNode.removeChild(resume);
        resume = null;
        played = true;
        video.muted = false;
        video.volume = 1;
      }
    }

    var saved = store(key);
    if (saved !== null && (saved >= CFG.resumeMin || saved === -1)) {
      startResume(saved);
    } else {
      startSap();
    }
    sizeClass();
    if (window.ResizeObserver) new ResizeObserver(sizeClass).observe(player);
    else window.addEventListener('resize', sizeClass);
  }

  function boot() {
    var hosts = document.querySelectorAll('[data-tnv-player]');
    for (var i = 0; i < hosts.length; i++) mount(hosts[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
